import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormBaseComponent } from "./../form-base/form-base.component";

@Component({
  selector: "app-form-opcao",
  templateUrl: "./form-opcao.component.html",
  styleUrls: ["../form-base/form-base.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormOpcaoComponent extends FormBaseComponent {}
